import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './cookies.component'

let module = angular.module('cookies', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('cookies', {
      url: '/cookies?token',
      component: 'cookies'
    })
})

.component('cookies', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/cookies/index.js